import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './drawerContent.module.css';

const styles = {
  icon: {
    fontSize: '5.5rem',
    width: '5.5rem',
    height: '5.5rem',
    marginTop: '3.5rem',
    marginBottom: '2.25rem',
  },
};

interface Props {
  icon: string;
  text: string[];
}

const NoItemsPane = ({ icon, text }: Props) => {
  return (
    <div className={classes.noItemsContainer}>
      <Icon style={styles.icon} color={colors.neutral.silver}>
        {icon}
      </Icon>
      {text.map((row, index) => (
        <p className={classes.noItemsText} key={index}>
          {row}
        </p>
      ))}
    </div>
  );
};

export default NoItemsPane;
